import React from 'react';
import { ReactComponent as LogoSmall } from 'src/assets/shs_logo_small_2026.svg';

const ShsLogoSmall: React.FC = () => {
    return (
        <div style={{ width: '40px' }}>
            <LogoSmall />
        </div>
    );
};

export default ShsLogoSmall;
